/**
 * Helpers centralizados de cálculo de IVA (iter 72).
 *
 * Espejo JavaScript de /app/backend/services/totals.py. Misma matemática,
 * mismo redondeo, mismas convenciones. Cualquier lógica IVA del frontend
 * debe pasar por aquí. Si modificas una fórmula, modifica también la
 * contraparte Python.
 *
 * Convención de modo:
 *   - pricesIncludeVat=true  → unit_price y line_total contienen IVA.
 *     Base = total / (1 + iva/100), IVA = total − base.
 *   - pricesIncludeVat=false → unit_price y line_total son SIN IVA.
 */

export function roundFinalPriceUp(amount) {
  // Iter 168 — espejo de services/totals.py::round_final_price_up (ceil al euro).
  const v = Math.round((Number(amount) || 0) * 1e6) / 1e6;
  return Math.ceil(v);
}

export function fmtPrice(amount, currency = "€") {
  // Enteros sin decimales ("71 €"); históricos con decimales tal cual ("70,20 €").
  const v = Number(amount) || 0;
  const isInt = Math.abs(v - Math.round(v)) < 0.005;
  const s = isInt ? String(Math.round(v)) : v.toFixed(2).replace(".", ",");
  return currency ? `${s} ${currency}` : s;
}

export function lineTotalWithVat(quantity, unitPrice, discountPct = 0) {
  const q = Number(quantity) || 0;
  const up = Number(unitPrice) || 0;
  const dp = Math.max(0, Math.min(100, Number(discountPct) || 0));
  return roundFinalPriceUp(q * up * (1 - dp / 100));
}

export function computeDocTotals(items, pricesIncludeVat = true, discountAmount = 0) {
  let subtotal = 0;
  let tax = 0;
  let total = 0;
  for (const it of items || []) {
    const lt = (it && it.line_total != null)
      ? Number(it.line_total) || 0
      : lineTotalWithVat(it?.quantity, it?.unit_price, it?.discount_pct);
    const vr = Number(it?.vat_rate) || 0;
    if (pricesIncludeVat) {
      const base = vr ? lt / (1 + vr / 100) : lt;
      subtotal += base;
      tax += lt - base;
      total += lt;
    } else {
      subtotal += lt;
      const lineTax = lt * (vr / 100);
      tax += lineTax;
      total += lt + lineTax;
    }
  }
  total -= Number(discountAmount) || 0;
  const r2 = (n) => Math.round(n * 100) / 100;
  return { subtotal: r2(subtotal), tax: r2(tax), total: r2(total) };
}
